var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 0C10.5656 0 10.2142 0.351423 10.2142 0.785714V10.2143H0.785623C0.351319 10.2143 -9.15527e-05 10.5657 -9.15527e-05 11C-9.15527e-05 11.4343 0.351331 11.7857 0.785623 11.7857H10.2142V21.2143C10.2142 21.6486 10.5656 22 10.9999 22C11.4342 22 11.7856 21.6486 11.7856 21.2143V11.7857H21.2142C21.6485 11.7857 21.9999 11.4343 21.9999 11C21.9999 10.5657 21.6485 10.2143 21.2142 10.2143H11.7856V0.785714C11.7856 0.351411 11.4342 0 10.9999 0Z",
    fill: "#7D8693"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGray);
export default __webpack_public_path__ + "static/media/add-gray.538e74592f7114f235f4e3e55a4519f7.svg";
export { ForwardRef as ReactComponent };